// Enums
export var MASK_TYPE;
(function (MASK_TYPE) {
    MASK_TYPE["LETTERS"] = "LETTERS";
    MASK_TYPE["NUMBERS"] = "NUMBERS";
    MASK_TYPE["NUMBERS_WITH_SPACES"] = "NUMBERS_WITH_SPACES";
    MASK_TYPE["ALPHANUMERIC"] = "ALPHANUMERIC";
    MASK_TYPE["ALPHANUMERIC_WITH_SPACES"] = "ALPHANUMERIC_WITH_SPACES";
    MASK_TYPE["LETTERS_HYPHEN_SPACE"] = "LETTERS_HYPHEN_SPACE";
})(MASK_TYPE || (MASK_TYPE = {}));
export var ERROR_EXECUTION;
(function (ERROR_EXECUTION) {
    ERROR_EXECUTION["ON_CHANGE"] = "onChange";
    ERROR_EXECUTION["ON_BLUR"] = "onBlur";
    ERROR_EXECUTION["ON_CHANGE_ON_BLUR"] = "onChangeOnBlur";
    ERROR_EXECUTION["NONE"] = "none";
})(ERROR_EXECUTION || (ERROR_EXECUTION = {}));
export var INTERNAL_ERROR_EXECUTION;
(function (INTERNAL_ERROR_EXECUTION) {
    INTERNAL_ERROR_EXECUTION["ON_CHANGE"] = "onChange";
    INTERNAL_ERROR_EXECUTION["ON_BLUR"] = "onBlur";
    INTERNAL_ERROR_EXECUTION["ON_CHANGE_ON_BLUR"] = "onChangeOnBlur";
    INTERNAL_ERROR_EXECUTION["NONE"] = "none";
})(INTERNAL_ERROR_EXECUTION || (INTERNAL_ERROR_EXECUTION = {}));
export var AUTOCAPITALIZE_TYPE;
(function (AUTOCAPITALIZE_TYPE) {
    AUTOCAPITALIZE_TYPE["OFF"] = "off";
    AUTOCAPITALIZE_TYPE["NONE"] = "none";
    AUTOCAPITALIZE_TYPE["ON"] = "on";
    AUTOCAPITALIZE_TYPE["SENTENCES"] = "sentences";
    AUTOCAPITALIZE_TYPE["WORDS"] = "words";
    AUTOCAPITALIZE_TYPE["CHARACTERS"] = "characters";
})(AUTOCAPITALIZE_TYPE || (AUTOCAPITALIZE_TYPE = {}));
export var AUTOCOMPLETE_TYPE;
(function (AUTOCOMPLETE_TYPE) {
    AUTOCOMPLETE_TYPE["ON"] = "on";
    AUTOCOMPLETE_TYPE["OFF"] = "off";
    AUTOCOMPLETE_TYPE["NAME"] = "name";
    AUTOCOMPLETE_TYPE["HONORIFIC_PREFIX"] = "honorific-prefix";
    AUTOCOMPLETE_TYPE["GIVEN_NAME"] = "given-name";
    AUTOCOMPLETE_TYPE["ADDITIONAL_NAME"] = "additional-name";
    AUTOCOMPLETE_TYPE["FAMILY_NAME"] = "family-name";
    AUTOCOMPLETE_TYPE["HONORIFIC_SUFFIX"] = "honorific-suffix";
    AUTOCOMPLETE_TYPE["NICKNAME"] = "nickname";
    AUTOCOMPLETE_TYPE["EMAIL"] = "email";
    AUTOCOMPLETE_TYPE["USERNAME"] = "username";
    AUTOCOMPLETE_TYPE["NEW_PASSWORD"] = "new-password";
    AUTOCOMPLETE_TYPE["CURRENT_PASSWORD"] = "current-password";
    AUTOCOMPLETE_TYPE["ONE_TIME_CODE"] = "one-time-code";
    AUTOCOMPLETE_TYPE["ORGANIZATION_TITLE"] = "organization-title";
    AUTOCOMPLETE_TYPE["ORGANIZATION"] = "organization";
    AUTOCOMPLETE_TYPE["STREET_ADDRESS"] = "street-address";
    AUTOCOMPLETE_TYPE["ADDRESS_LINE1"] = "address-line1";
    AUTOCOMPLETE_TYPE["ADDRESS_LINE2"] = "address-line2";
    AUTOCOMPLETE_TYPE["ADDRESS_LINE3"] = "address-line3";
    AUTOCOMPLETE_TYPE["ADDRESS_LEVEL4"] = "address-level4";
    AUTOCOMPLETE_TYPE["ADDRESS_LEVEL3"] = "address-level3";
    AUTOCOMPLETE_TYPE["ADDRESS_LEVEL2"] = "address-level2";
    AUTOCOMPLETE_TYPE["ADDRESS_LEVEL1"] = "address-level1";
    AUTOCOMPLETE_TYPE["COUNTRY"] = "country";
    AUTOCOMPLETE_TYPE["POSTAL_CODE"] = "postal-code";
    AUTOCOMPLETE_TYPE["CC_NAME"] = "cc-name";
    AUTOCOMPLETE_TYPE["CC_GIVEN_NAME"] = "cc-given-name";
    AUTOCOMPLETE_TYPE["CC_ADDITIONAL_NAME"] = "cc-additional-name";
    AUTOCOMPLETE_TYPE["CC_FAMILY_NAME"] = "cc-family-name";
    AUTOCOMPLETE_TYPE["CC_NUMBER"] = "cc-number";
    AUTOCOMPLETE_TYPE["CC_EXP"] = "cc-exp";
    AUTOCOMPLETE_TYPE["CC_EXP_MONTH"] = "cc-exp-month";
    AUTOCOMPLETE_TYPE["CC_EXP_YEAR"] = "cc-exp-year";
    AUTOCOMPLETE_TYPE["CC_CSC"] = "cc-csc";
    AUTOCOMPLETE_TYPE["CC_TYPE"] = "cc-type";
    AUTOCOMPLETE_TYPE["TRANSACTION_CURRENCY"] = "transaction-currency";
    AUTOCOMPLETE_TYPE["TRANSACTION_AMOUNT"] = "transaction-amount";
    AUTOCOMPLETE_TYPE["LANGUAGE"] = "language";
    AUTOCOMPLETE_TYPE["BDAY"] = "bday";
    AUTOCOMPLETE_TYPE["BDAY_DAY"] = "bday-day";
    AUTOCOMPLETE_TYPE["BDAY_MONTH"] = "bday-month";
    AUTOCOMPLETE_TYPE["BDAY_YEAR"] = "bday-year";
    AUTOCOMPLETE_TYPE["SEX"] = "sex";
    AUTOCOMPLETE_TYPE["TEL"] = "tel";
    AUTOCOMPLETE_TYPE["TEL_COUNTRY_CODE"] = "tel-country-code";
    AUTOCOMPLETE_TYPE["TEL_NATIONAL"] = "tel-national";
    AUTOCOMPLETE_TYPE["TEL_AREA_CODE"] = "tel-area-code";
    AUTOCOMPLETE_TYPE["TEL_LOCAL"] = "tel-local";
    AUTOCOMPLETE_TYPE["TEL_EXTENSION"] = "tel-extension";
    AUTOCOMPLETE_TYPE["IMPP"] = "impp";
    AUTOCOMPLETE_TYPE["URL"] = "url";
    AUTOCOMPLETE_TYPE["PHOTO"] = "photo";
    AUTOCOMPLETE_TYPE["PHOTO_URL"] = "photo-url";
    AUTOCOMPLETE_TYPE["ROLE"] = "role";
    AUTOCOMPLETE_TYPE["ORGANIZATION_ROLE"] = "organization-role";
    AUTOCOMPLETE_TYPE["NOTE"] = "note";
    AUTOCOMPLETE_TYPE["SECTION"] = "section";
    AUTOCOMPLETE_TYPE["SEARCH"] = "search";
    AUTOCOMPLETE_TYPE["BOOKMARK"] = "bookmark";
    AUTOCOMPLETE_TYPE["HOME"] = "home";
    AUTOCOMPLETE_TYPE["WORK"] = "work";
    AUTOCOMPLETE_TYPE["MOBILE"] = "mobile";
    AUTOCOMPLETE_TYPE["FAX"] = "fax";
    AUTOCOMPLETE_TYPE["PAGER"] = "pager";
    AUTOCOMPLETE_TYPE["OTHER"] = "other";
})(AUTOCOMPLETE_TYPE || (AUTOCOMPLETE_TYPE = {}));
//# sourceMappingURL=input.js.map